var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66989 3.47899C10.8116 1.507 13.6584 1.507 14.8001 3.47899L23.0675 17.7629C24.2093 19.7353 22.7865 22.2113 20.5023 22.2113H3.96766C1.68351 22.2113 0.26071 19.7353 1.4025 17.763C1.40252 17.763 1.40249 17.763 1.4025 17.763L9.66989 3.47899ZM11.0013 4.24981L2.73401 18.5337C2.18509 19.4818 2.87024 20.6729 3.96766 20.6729H20.5023C21.5998 20.6729 22.285 19.4819 21.736 18.5338L13.4687 4.24981C12.9196 3.30133 11.5504 3.30133 11.0013 4.24981Z",
    fill: "curruntColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.235 14.8546C11.6311 14.8546 11.1371 14.237 11.1371 13.4822V10.7374C11.1371 9.98256 11.6311 9.36498 12.235 9.36498C12.8389 9.36498 13.3329 9.98256 13.3329 10.7374V13.4822C13.3329 14.237 12.8389 14.8546 12.235 14.8546Z",
    fill: "curruntColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3329 18.1483H11.1371V15.9525H13.3329V18.1483Z",
    fill: "curruntColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutline);
export default __webpack_public_path__ + "static/media/warning-outline.d8cb462713264bfc80004944e5c0ec6e.svg";
export { ForwardRef as ReactComponent };